import api from '../../api/axiosInstance';
import { API_ENDPOINTS } from '../../config/apiconfig';

/**
 * Fetches a single challan by its ID.
 * @param {number} id The ID of the challan.
 * @returns {Promise<object>} The challan data.
 */
export const getChallanById = async (id) => {
  if (!id) {
    throw new Error('Challan ID is required');
  }
  const response = await api.get(`/challans/getByChallanId/${id}`);
  return response.data;
};

/**
 * Fetches available cylinder serial numbers for a given product name.
 * @param {string} cylinderName The name of the cylinder/product.
 * @returns {Promise<Array<string>>} A list of serial numbers.
 */
export const getCylinderSrNo = async (cylinderName) => {
  if (!cylinderName) {
    return [];
  }
  const response = await api.get(API_ENDPOINTS.CYLINDER.GET_SRNO_BY_NAME(cylinderName));
  return response.data;
};

export const challanApi = {
  getChallanById,
  getCylinderSrNo,
  // Keep other functions from your existing API file
  downloadChallan: (id) => api.get(API_ENDPOINTS.CHALLANS.DOWNLOAD(id), { responseType: 'blob' }),
  deleteChallanById: (id) => api.delete(API_ENDPOINTS.CHALLANS.DELETE_BY_ID(id)),
};